import { render, staticRenderFns } from "./supplier-table.vue?vue&type=template&id=eb56271e&scoped=true"
import script from "./supplier-table.vue?vue&type=script&lang=js"
export * from "./supplier-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb56271e",
  null
  
)

export default component.exports